export default __webpack_public_path__ + "static/media/frutiger-45light.3e7b0221.woff";